import { IAffectedTransactionsByPositionIdParams, ListResult } from '@shared/api';
import { Api } from '../../Api';
import { IAffectedTransactions, ISettingsTransactionsDto } from './interfaces';
import { ISettingsTransactionsGetQuery } from './query';

export class Transactions {
    private static _basePath = '/TransactionLot';

    public static getMethods(parentPath: string) {
        const basePath = `${parentPath}${Transactions._basePath}`;
        return {
            async get(query: ISettingsTransactionsGetQuery) {
                const path = '/';
                return await Api.get<ListResult<ISettingsTransactionsDto>>({
                    path: `${basePath}${path}`,
                    query,
                });
            },

            async getAffectedTransactions({ positionId }: IAffectedTransactionsByPositionIdParams) {
                const path = `/positions/${positionId}/sequence`;
                return await Api.get<IAffectedTransactions>({
                    path: `${basePath}${path}`,
                });
            },
        };
    }
}
